/* eslint-disable no-unused-vars */
import {
    Progress,
    Button,
    PageHeader,
} from 'antd';
import { IoMdClose } from 'react-icons/io';

import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { DriverInformation, SendInvitation } from '../../components/NewDriver';
import { IDriver } from '../../interfaces/driver.interface';

const NewDriver: FC = () => {
    const { t: ts } = useTranslation('shared');

    const [step, setStep] = useState(1);
    const [progress, setProgress] = useState(33.33);
    const [driverData, setDriverData] = useState();

    const navigate = useNavigate();

    const nextStep = () => {
        setStep((step: number) => step + 1);
        setProgress((progress: number) => progress + 33.33);
    };

    const previousStep = () => {
        setStep((step: number) => step - 1);
        setProgress((progress: number) => progress - 33.33);
    };

    return (
        <div className="screen">
            <PageHeader
                title={`${ts('ACTIONS.ADD')} ${ts('SINGLES.DRIVER')}`}
                extra={(
                    <Button
                        type="primary"
                        size="small"
                        icon={<IoMdClose style={{ verticalAlign: 'middle' }} />}
                        onClick={() => navigate('/drivers')}
                    />
                )}
            />
            <Progress
                percent={progress}
                showInfo={false}
                strokeColor="#6C8EEF"
            />
            <div className="section">
                {
                    step === 1 && (
                        <DriverInformation
                            setDriverData={setDriverData}
                            nextStep={nextStep}
                            driverData={driverData}
                        />
                    )
                }
                {
                    step === 2 && (
                        <SendInvitation
                            driverData={driverData as unknown as IDriver}
                            previousStep={previousStep}
                        />
                    )
                }
            </div>
        </div>
    );
};

export { NewDriver };
